/**
 * created by
 * 统计展示
 */
import React, {Component} from "react";
import ReactEcharts from "echarts-for-react";
import {Radio, Button, message, DatePicker, Tabs, Empty} from "antd";
import {headers, headerJson, getManuscriptQuantity, getInfoFromLocalStorage} from "../../../../actions";
import moment from "moment";
import *as Utils from "../../../../utils";
import {connect} from "react-redux";
import BaseComponent from "../../../../base/BaseComponent";

const {RangePicker} = DatePicker;
let option = {

    tooltip: {
        trigger: "item",
        formatter: "{b}: {c}"
    },
    title: [{}],
    grid: [{
        top: 60,
        width: "92%",
        bottom: "10%",
        left: "5%",
        containLabel: true,
    }],
    xAxis: [{
        type: "value",
        splitLine: {
            show: false
        },
        minInterval: 1,
        boundaryGap: [0, 0.01]
    }],
    yAxis: [{
        type: "category",
        data: ["已发布", "部门通过", "已提交"],
        axisLabel: {
            interval: 0,
            rotate: 0
        },
        splitLine: {
            show: true,
           
        },
    }],
    series: [{
        type: "bar",
        stack: "chart",
        barWidth: "40%",
        z: 4,
        label: {
            normal: {
                show: true,
                position: "right",
                textStyle: {
                    color: "#555",
                    fontSize: 12
                }
            }
        },
        itemStyle: {
            normal: {
                color: "#4C84C9",
                opacity: 1
            }
        },
        data: [0, 0, 0, 0]
    }]
};
const {TabPane} = Tabs;

class PMSStoryStatisticsSMG extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
        
            btnText: "本周",
            option: option,
            lastMonthResults: JSON.parse(JSON.stringify(option)),
            dayResults: JSON.parse(JSON.stringify(option)),
            yesterdayResults: JSON.parse(JSON.stringify(option)),
            weekResults: JSON.parse(JSON.stringify(option)),
            mounthResults: JSON.parse(JSON.stringify(option)),
            yearResults: JSON.parse(JSON.stringify(option)),
            start: moment().week(moment().week()).startOf('week'),
            end: moment().week(moment().week()).endOf('week'),
            TabPane: [
                {
                    name: '个人投稿统计',
                    url: 'person',
                    auth:false,
                },
                {
                    name: '部门投稿统计',
                    url: 'dept',
                    auth:false,
                },
                {
                    name: '媒体投稿统计',
                    url: 'media',
                    auth:false,
                },
            ],
            dataSource: [],
            currentActiveKey: {},//当前点击
        };
    }

    componentWillMount() {
        //绑定权限
        let personStatic = this.permissionCheck('personStatic');
        let deptStatic = this.permissionCheck('deptPermission');
        let mediaStatic = this.permissionCheck('mediaPermission');
        let currentActiveKey = {};
        let TabPane = [
            {
                name: '个人稿件统计',
                url: 'person',
                auth: personStatic,
            },
            {
                name: '部门稿件统计',
                url: 'dept',
                auth: deptStatic,
            },
            {
                name: '媒体稿件统计',
                url: 'media',
                auth: mediaStatic,
            },
        ];
        for(let i=0;i<TabPane.length;i++){
            if(TabPane[i].auth){
                currentActiveKey = TabPane[i];
                break;
            }
        }

        console.log(currentActiveKey);
        this.setState({
            currentActiveKey: currentActiveKey, TabPane,
        },()=>{
            let {currentActiveKey, start, end} = this.state;
            this.getStatistics(currentActiveKey, {start, end})
        });
    }

    // componentDidMount() {
    //     let {currentActiveKey, start, end} = this.state;
    //     this.getStatistics(currentActiveKey, {start, end})
    // }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    // 根据主题修改颜色
    backgroundColorChangeByTheme = option => {
        // 获取主题颜色
        let bgColor = this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");
        let optionTemp = {...option};
        if (option&&Object.keys(option).length) {
            optionTemp['series'].forEach(item=>{
                item.itemStyle.normal.color = bgColor
            })
        }
        return optionTemp
    }

    handleSizeChange = e => {
        let {currentActiveKey} = this.state;
        let data = e.target.value;
        let start;
        let end;
        if (data === "上月") {
            this.setState({option: this.backgroundColorChangeByTheme(this.state.lastMonthResults)});
        } else if (data === "今日") {
            start = moment().day(moment().day()).startOf('day');
            end = moment().day(moment().day()).endOf('day');
            this.getStatistics(currentActiveKey, {start, end});
        } else if (data === "昨日") {
            start = moment().day(moment().day() - 1).startOf('day');
            end = moment().day(moment().day() - 1).endOf('day');
            console.log(moment().day(moment().day() - 1).startOf('day'));
            this.getStatistics(currentActiveKey, {start, end});
        } else if (data === "本周") {
            start = moment().week(moment().week()).startOf('week');
            end = moment().week(moment().week()).endOf('week');
            this.getStatistics(currentActiveKey, {start, end});
        } else if (data === "本月") {
            start = moment().month(moment().month()).startOf('month');
            end = moment().month(moment().month()).endOf('month');
            this.getStatistics(currentActiveKey, {start, end});
        } else if (data === "本年") {
            start = moment().year(moment().year()).startOf('year');
            end = moment().year(moment().year()).endOf('year');
            console.log(start, end);
            this.getStatistics(currentActiveKey, {start, end});
        }
        this.setState({btnText: e.target.value, start, end});
    };

    rangePickerChange = (data, dateString) => {
        let {currentActiveKey} = this.state;
        this.rangePicker = dateString;
        // console.log(data, dateString);
        // let start = data[0].startOf('day');
        // let end = data[1].endOf('day');
        let start = data && data[0] ? data[0].startOf('day') : null;
        let end = data && data[1] ? data[1].endOf('day') : null;
        console.log(start, end);
        // /^[^A-Za-z]*$/.test(start);
        this.setState({
            start, end
        });
        this.getStatistics(currentActiveKey, {start, end});
        this.setState({btnText: ""})
    };

    render() {
        let {currentActiveKey} = this.state;
        if (JSON.stringify(currentActiveKey) === "{}") {
            return (
                <div style={{position: "relative"}}>
                    <Empty style={{marginTop:80}}/>
                </div>
            )
        }
        return (
            <div style={{position: "relative",}}>
                <div style={{height: 262, width: "100%",}}>
                    <ReactEcharts
                        option={this.state.option}
                        notMerge={true}
                        lazyUpdate={true}
                        style={{
                            width: "96%",
                            height: "235px",
                            textAlign: "center",
                            marginBottom: '10px',
                            position: "absolute",
                            top: 20
                        }}
                    />
                    <span
                        style={{
                            marginBottom: '10px',
                            position: "absolute",
                            bottom: 20,
                            right:10,
                            color: 'rgba(0, 0, 0, 0.45)',
                            fontSize: '12px'
                        }}>单位：篇</span>
                </div>
                {this.renderTabs()}
                <div style={{height: 32, position: "absolute", right: 0, top: 10}} className={'selectedPicker'}>
                    <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}
                                 style={{marginRight: '10px'}}>
                        <Radio.Button value="今日">今日</Radio.Button>
                        <Radio.Button value="昨日">昨日</Radio.Button>
                        <Radio.Button value="本周">本周</Radio.Button>
                        <Radio.Button value="本月">本月</Radio.Button>
                        <Radio.Button value="本年">本年</Radio.Button>
                    </Radio.Group>
                    <RangePicker getPopupContainer={triggerNode => triggerNode.parentNode} allowClear value={[this.state.start, this.state.end]}
                                 style={{width: 230, marginRight: 20}} onChange={this.rangePickerChange}/>
                </div>
                <style>
                    {
                        `
                                 .selectedPicker .ant-calendar-picker-input.ant-input{
                                    background:#f6f8fd;
                                 }
                                 .selectedPicker .ant-calendar-input-wrap .ant-calendar-date-input-wrap .ant-calendar-input {
                                    
                                    width:150px !important;
                                    background:red;
                                 }
                         `
                    }
                </style>
            </div>
        );
    }

    // 稿件统计选项卡
    renderTabs = () => {
        return (
            <div className={'tabsItem'} style={{position: "absolute", top: 0, left: '24px'}}>
                <Tabs defaultActiveKey="0"
                      onChange={this.rangeTabsChange} style={{border: 'none'}}>
                    {
                        this.state.TabPane.map((item, index) => {
                            if(item. auth){
                                return (
                                    <TabPane tab={item.name} key={index}></TabPane>
                                )
                            }
                        })
                    }
                </Tabs>
                <style>
                    {`
                          .tabsItem  .ant-tabs-bar{
                            border:none
                          }
                          .tabsItem .ant-tabs-nav .ant-tabs-tab{
                            marginRight:7px;
                            padding:12px 4px;
                          }
                          .tabsItem .ant-tabs-ink-bar{
                            width:92px !important;
                            height:3px !important;
                          }
                    `}
                </style>
            </div>
        )
    };
    // 选项卡改变
    rangeTabsChange = (key) => {
        let {currentActiveKey, TabPane, start, end,option} = this.state;
        let thisTab = TabPane.find((item, index) => index == key);
        this.setState({
            currentActiveKey: thisTab
        });
        currentActiveKey = thisTab;
        // console.log(currentActiveKey, start, end);
        this.getStatistics(currentActiveKey, {start, end})
    };
    // 获取稿件统计
    getStatistics = (currentActiveKey, {start, end}) => {
        let {option} = this.state;
        let params = {
            start: new Date(start).getTime(),
            end: new Date(end).getTime(),
        };
        if(JSON.stringify(currentActiveKey)==="{}"){
            return
        }
        this.request({
            url: `/cm-sites-pms/index/statistics/${currentActiveKey.url}`,
            body: params,
            callBack: (res) => {
                // console.log(res);
                if (res) {
                    let optionData= {"已提交": 0, "部门通过": 0, "已发布": 0};
                    if(res){
                        let current=res;
                        if(currentActiveKey.url=='person'){
                            optionData= {"已提交": current.submit, "部门通过": current.deptPass, "已发布": current.publish}
                        }else if(currentActiveKey.url=='dept'){
                            optionData= {"已收到": current.submit, "部门通过": current.deptPass, "已发布": current.publish}
                        }else if(currentActiveKey.url=='media'){
                            optionData= {"已收到": current.receive,  "已发布": current.publish}
                        }
                    }
                    this.setState({ option:  this.backgroundColorChangeByTheme(generateOptions(optionData))})
                }
            }
        })
    };
}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config
    };
}

export default connect(mapStateToProps)(PMSStoryStatisticsSMG);


export const generateOptions = (data) => {
    let options = {
        tooltip: {
            trigger: "item",
            formatter: "{b}: {c}"
        },
        title: [{}],
        grid: [{
            top: 60,
            width: "92%",
            bottom: "10%",
            left: "5%",
            containLabel: true
        }],
        xAxis: [{

            type: "value",
            splitLine: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    color: '#000000'
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#D9D9D9"
                }
            },
            axisTick: {
                show: false
            },
            minInterval: 1,
            boundaryGap: [0, 0.01]
        }],
        yAxis: [{
            type: "category",
            data: Object.keys(data),
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
                rotate: 0,
                textStyle: {
                    color: '#000000'
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#D9D9D9"
                }
            },
            splitLine: {
                show: true,

            },

    }],
        series: [{
            type: "bar",
            stack: "chart",
            barWidth: "40%",
            z: 4,
            label: {
                normal: {
                    show: true,
                    position: "right",
                    textStyle: {
                        color: "#555",
                        fontSize: 12
                    }
                }
            },
            itemStyle: {
                normal: {
                    color: "#4C84C9",
                    opacity: 1
                }
            },
            data: Object.keys(data).map(function (key) {
                return data[key];
            })
        }]
    };

    return options;
};